import CatalogPhaseEvents from "@/pages/eaf/catalogs/phase-events";
import {
	Divider,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	ListSubheader,
	useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import AlertLimit from "../pages/caster/alert/AlertLimit";
import CatalogLostStrandTypes from "../pages/caster/catalogs/lost-strand-types";
import { CatalogLowTonnageReasons } from "../pages/caster/catalogs/low-tonnage-reasons";
import CatalogMoldSize from "../pages/caster/catalogs/mold-sizes";
import CatalogMold from "../pages/caster/catalogs/molds";
import { CatalogPourbackReasons } from "../pages/caster/catalogs/pourback-reasons";
import CatalogCategories from "../pages/delays/categories";
import DelayCodePage from "../pages/delays/codes";
import CatalogElement from "../pages/laboratory/catalogs/elements";
import CatalogMechanicalTest from "../pages/laboratory/catalogs/mechanicalTest";
import CatalogResultSource from "../pages/laboratory/catalogs/resultSource";
import CatalogSampleType from "../pages/laboratory/catalogs/sampleType";
import CatalogBuckets from "../pages/steel/catalogs/buckets";
import CatalogGrade from "../pages/steel/catalogs/grade";
import CatalogLadle from "../pages/steel/catalogs/ladle";
import CatalogMaterial from "../pages/steel/catalogs/materials";
import CatalogSection from "../pages/steel/catalogs/section";

const components = [
	{
		path: "alerts",
		sidebar: () => <div>alerts</div>,
		main: () => <AlertLimit />,
	},
	{
		path: "lab-element",
		sidebar: () => <div>elements</div>,
		main: () => <CatalogElement />,
	},
	{
		path: "lab-mechanical-test",
		sidebar: () => <div>mechanical tests</div>,
		main: () => <CatalogMechanicalTest />,
	},
	{
		path: "lab-result-source",
		sidebar: () => <div>result sources</div>,
		main: () => <CatalogResultSource />,
	},
	{
		path: "lab-sample-type",
		sidebar: () => <div>sample types</div>,
		main: () => <CatalogSampleType />,
	},
	{
		path: "caster-molds",
		sidebar: () => <div>Molds</div>,
		main: () => <CatalogMold />,
	},
	{
		path: "caster-mold-sizes",
		sidebar: () => <div>Mold Sizes</div>,
		main: () => <CatalogMoldSize />,
	},
	{
		path: "caster-lost-strand-types",
		sidebar: () => <div>Lost Strand Types</div>,
		main: () => <CatalogLostStrandTypes />,
	},
	{
		path: "caster-pourback-reasons",
		sidebar: () => <div>Pourback Reasons</div>,
		main: () => <CatalogPourbackReasons />,
	},
	{
		path: "caster-low-tonnage-reasons",
		sidebar: () => <div>Low Tonnage Reasons</div>,
		main: () => <CatalogLowTonnageReasons />,
	},
	{
		path: "eaf-phase-events",
		sidebar: () => <div>Phase Events</div>,
		main: () => <CatalogPhaseEvents />,
	},
	{
		path: "steel-grade",
		sidebar: () => <div>grades</div>,
		main: () => <CatalogGrade />,
	},
	{
		path: "steel-grade/:gradeId",
		sidebar: () => <div>grades</div>,
		main: () => <CatalogGrade />,
	},
	{
		path: "steel-ladle",
		sidebar: () => <div>ladles</div>,
		main: () => <CatalogLadle />,
	},
	{
		path: "steel-section",
		sidebar: () => <div>sections</div>,
		main: () => <CatalogSection />,
	},
	{
		path: "steel-material",
		sidebar: () => <div>materials</div>,
		main: () => <CatalogMaterial />,
	},
	{
		path: "steel-buckets",
		sidebar: () => <div>buckets</div>,
		main: () => <CatalogBuckets />,
	},
	{
		path: "delay-categories",
		sidebar: () => <div>Delay Categories</div>,
		main: () => <CatalogCategories />,
	},
	{
		path: "delay-codes-eaf",
		sidebar: () => <div>EAF Delay Codes</div>,
		main: () => <DelayCodePage delayAreaAssetName="EAF" />,
	},
	{
		path: "delay-codes-caster",
		sidebar: () => <div>CASTER Delay Codes</div>,
		main: () => <DelayCodePage delayAreaAssetName="Caster" />,
	},
];

const sidebar = ({ option }: { option: string }) => {
	const theme = useTheme();
	const listSubheaderStyle = {
		backgroundColor: theme.palette.background.paper,
		color: theme.palette.primary.main,
		fontWeight: 600,
	};
	return (
		<>
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Laboratory</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "lab-element"}
						component={Link}
						to="/configuration/lab-element"
					>
						<ListItemText primary="Elements" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "lab-mechanical-test"}
						component={Link}
						to="/configuration/lab-mechanical-test"
					>
						<ListItemText primary="Mechanical Tests" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "lab-result-source"}
						component={Link}
						to="/configuration/lab-result-source"
					>
						<ListItemText primary="Result Sources" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "lab-sample-type"}
						component={Link}
						to="/configuration/lab-sample-type"
					>
						<ListItemText primary="Sample Types" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Caster</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "caster-molds"}
						component={Link}
						to="/configuration/caster-molds"
					>
						<ListItemText primary="Molds" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "caster-mold-sizes"}
						component={Link}
						to="/configuration/caster-mold-sizes"
					>
						<ListItemText primary="Mold Sizes" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "caster-lost-strand-types"}
						component={Link}
						to="/configuration/caster-lost-strand-types"
					>
						<ListItemText primary="Lost Strand Types" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "caster-pourback-reasons"}
						component={Link}
						to="/configuration/caster-pourback-reasons"
					>
						<ListItemText primary="Pourback Reasons" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "caster-low-tonnage-reasons"}
						component={Link}
						to="/configuration/caster-low-tonnage-reasons"
					>
						<ListItemText primary="Low Tonnage Reasons" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Steel</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "steel-grade"}
						component={Link}
						to="/configuration/steel-grade"
					>
						<ListItemText primary="Grades" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "steel-ladle"}
						component={Link}
						to="/configuration/steel-ladle"
					>
						<ListItemText primary="Ladles" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "steel-section"}
						component={Link}
						to="/configuration/steel-section"
					>
						<ListItemText primary="Sections" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "steel-material"}
						component={Link}
						to="/configuration/steel-material"
					>
						<ListItemText primary="Materials" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						component={Link}
						to="/configuration/eaf-phase-events"
						selected={option === "eaf-phase-events"}
					>
						<ListItemText primary="Phase Events" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "steel-buckets"}
						component={Link}
						to="/configuration/steel-buckets"
					>
						<ListItemText primary="Buckets" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader style={listSubheaderStyle}>Delays</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "delay-categories"}
						component={Link}
						to="/configuration/delay-categories"
					>
						<ListItemText primary="Categories" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "delay-codes-eaf"}
						component={Link}
						to="/configuration/delay-codes-eaf"
					>
						<ListItemText primary="EAF Codes" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "delay-codes-caster"}
						component={Link}
						to="/configuration/delay-codes-caster"
					>
						<ListItemText primary="Caster Codes" />
					</ListItemButton>
				</ListItem>
			</List>
		</>
	);
};

const customConfigurations = [components, sidebar];

export { customConfigurations };
